import { ActionTree } from 'vuex'
import { TriggeredActionState } from '@/store/triggeredActions/index'
import { RootState } from '@/store'
import { TriggeredActionAPI } from '@/api/backend-client'

export const actions: ActionTree<TriggeredActionState, RootState> = {
    async fetchData({ getters, commit }): Promise<void> {
        try {
            commit('fetchData')
            commit('fetchDataSuccess', await TriggeredActionAPI.getPaged(getters.requestParams))
        } catch (error) {
            commit('fetchDataFailure', error)
        }
    },

    async setPage({ commit, dispatch}, payload: { page: number }): Promise<void> {
        commit('setPage', payload)
        dispatch('fetchData')
    },

    async nextPage({ state, commit, dispatch }): Promise<void> {
        commit('setPage', { page: state.page + 1 })
        dispatch('fetchData')
    },

    async prevPage({ state, commit, dispatch }): Promise<void> {
        commit('setPage', { page: state.page - 1 })
        dispatch('fetchData')
    },

    async applyOrder({ commit, dispatch }, payload: { field: string, direction: string}): Promise<void> {
        commit('applyOrder', payload)
        commit('setPage', { page: 1})
        dispatch('fetchData')
    },

    async applyActiveFilter({commit, dispatch}, payload: { priorityFilter: number[] }): Promise<void> {
        commit('applyActiveFilter', payload)
        commit('setPage', { page: 1})
        dispatch('fetchData')
    },

    async applyCompanyFilter({ commit, dispatch }, payload: { query: string}): Promise<void> {
        commit('applyCompanyFilter', payload)
        commit('setPage', { page: 1 })
        dispatch('fetchData')
    },

    async applyNameFilter({ commit, dispatch }, payload: { query: string }): Promise<void> {
        commit('applyNameFilter', payload)
        commit('setPage', { page: 1 })
        dispatch('fetchData')
    },
}
